import {createSlice} from '@reduxjs/toolkit';
import {baseSetValue} from "../../utils";
import {NowPlaying, PlayerStatus} from "./types";

export interface PlayerSliceState {
    status: PlayerStatus;
    nowPlaying?: NowPlaying;
    isInitiatedByPlayer?: boolean;
    totalDuration: number;
    shuffle: boolean;
}

const initialState: PlayerSliceState = {
    status: 'Initial',
    totalDuration: 0,
    shuffle: false,
};

export const reducers = createSlice({
    name: 'player',
    initialState,
    reducers: {
        setValue: baseSetValue<PlayerSliceState>()
    },
});

export const {setValue} = reducers.actions;
export default reducers.reducer;
